import { render, staticRenderFns } from "./ServicesReservationEmployeeBenefits.vue?vue&type=template&id=64194da2&scoped=true&"
import script from "./ServicesReservationEmployeeBenefits.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationEmployeeBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64194da2",
  null
  
)

export default component.exports